module.exports = __webpack_public_path__ + "static/media/P1_S10_1.c0a08733.png";